import React from "react";
import styles from "./InputBox.module.css";
import AssetsPack from "../util/AssetsPack.js";
import ErrorText from "./ErrorText";
import clsx from "clsx";
import ImageComponent from "./ImageComponent";

export enum InputBoxState {
  default,
  error,
  success,
}

export enum InputBoxRoundedCornors {
  top,
  bottom,
  middle,
  all,
}

type InputBoxProps = {
  state?: InputBoxState;
  roundedCornors?: InputBoxRoundedCornors;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  [key: string]: any;
  errorMessage?: string | undefined;
  frontIcon?: string | undefined;
  blurBg?: boolean;
};

export default function InputBox({
  state = InputBoxState.default,
  roundedCornors = InputBoxRoundedCornors.all,
  onClick,
  errorMessage = undefined,
  frontIcon,
  blurBg = false,
  ...props
}: InputBoxProps) {
  const getStateStyles = (state: InputBoxState) => {
    switch (state) {
      case InputBoxState.error:
        return {
          stateClassStyle: styles["error"],
          icon: AssetsPack.icons.ICON_CLOSE_RED_CIRCLE.default,
        };
      case InputBoxState.success:
        return {
          icon: onClick
            ? AssetsPack.icons.ICON_ARROW_RIGHT_GOLD_CIRCLE.default
            : AssetsPack.icons.ICON_CHECK_GREEN_CIRCLE.default,
        };
      default:
        return {};
    }
  };

  const getRoundedCornersStyle = (roundedCorners: InputBoxRoundedCornors) => {
    switch (roundedCorners) {
      case InputBoxRoundedCornors.bottom:
        return styles["bottom"];
      case InputBoxRoundedCornors.top:
        return styles["top"];
      case InputBoxRoundedCornors.middle:
        return styles["middle"];
      default:
        return styles["all"];
    }
  };

  const { stateClassStyle, icon } = getStateStyles(state);
  const roundedCornorsStyle = getRoundedCornersStyle(roundedCornors);

  const handleClick = (event: React.MouseEvent<HTMLImageElement>) => {
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <>
      <div
        className={clsx(
          styles["input-wrapper"],
          stateClassStyle,
          roundedCornorsStyle,
          { [styles["input-wrapper-blur"]]: blurBg }
        )}
      >
        <input
          className={clsx(styles["input-field"], {
            [styles["input-field-search"]]: frontIcon,
          })}
          {...props}
        />
        {icon && (
          <ImageComponent
            src={icon}
            className={styles["icon"]}
            onClick={handleClick}
          />
        )}
        {frontIcon && (
          <ImageComponent
            src={frontIcon}
            className={styles["search-icon"]}
            onClick={handleClick}
          />
        )}
      </div>
      {errorMessage && <ErrorText>{errorMessage}</ErrorText>}
    </>
  );
}
